import Vue from 'vue'
import Router from 'vue-router'

import Home from '../pages/Home'
import Login from '../pages/Login'
import LoginJointQuery from '../pages/LoginJointQuery'
import LoginRepairApply from '../pages/LoginRepairApply' //网络报修 登录页面
import bindingPage from '../pages/bindingPage'
import bindingPageJointQuery from '../pages/bindingPageJointQuery'
import bindingPageRepairApply from '../pages/bindingPageRepairApply' //网络报修 绑定页面
import NotFound from '../pages/NotFound'
import indexMenu from '../pages/indexMenu'
import indexMenuRepairApply from '../pages/indexMenuRepairApply' //网络报修 菜单栏页面
import StudentRoomManger from '../pages/StudentRoomManger'
import StudentRoomMangerTwo from '../pages/StudentRoomMangerTwo'
import FloorSituation from '../pages/FloorSituation'
import indexMenuJointQuery from '../pages/indexMenuJointQuery'
import CheckInQuery from '../pages/CheckInQuery'
import BuildingQuery from '../pages/BuildingQuery'
import CompreHensivelyQuery from '../pages/CompreHensivelyQuery'
import RoomChangeApplication from '../pages/RoomChangeApplication'
import RoomChange from '../pages/RoomChange'
import RoomChangeDetial from '../pages/RoomChangeDetial'
import RoomChangeSH from '../pages/RoomChangeSH'
import RoomChangeQR from '../pages/RoomChangeQR'
import RepairApply from '../pages/RepairApply' ////报修申请
import RepairApplyDetial from '../pages/RepairApplyDetial' ////报修申请
import RepairManger from '../pages/RepairManger' ////维修管理
import RepairMangerDetial from '../pages/RepairMangerDetial' ////维修管理详情
import FusePackageProblem from '../pages/FusePackageProblem' ////融合套餐问题
import DelayedMaintenanceAudit from '../pages/DelayedMaintenanceAudit' ////延迟维修审核
// import realTimeCheckSleep from '../pages/realTimeCheckSleep' ////事实查寝（辅导员）
import DormitoryManagement from '../pages/DormitoryManagement' //舍区老师宿舍管理

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  routes: [
    
    {
      path: '/',
      redirect: '/login'
    },
    
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // {
    //   path: '/loginJointQuery',
    //   name: 'loginJointQuery',
    //   component: LoginJointQuery
    // }, 
    // {
    //   path: '/LoginRepairApply',
    //   name: 'LoginRepairApply',
    //   component: LoginRepairApply
    // },
    {
      path: '/indexMenu',
      name: 'indexMenu',
      component: indexMenu
    },
    {
      path: '/indexMenuJointQuery',
      name: 'indexMenuJointQuery',
      component: indexMenuJointQuery
    },
    {
      path: '/indexMenuRepairApply',
      name: 'indexMenuRepairApply',
      component: indexMenuRepairApply
    }, 
    {
      path: '/bindingPage',
      name: 'bindingPage',
      component: bindingPage
    },
    // {
    //   path: '/bindingPageJointQuery',
    //   name: 'bindingPageJointQuery',
    //   component: bindingPageJointQuery
    // },
    // {
    //   path: '/bindingPageRepairApply',
    //   name: 'bindingPageRepairApply',
    //   component: bindingPageRepairApply
    // },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/studentRoomManger',
      name: 'studentRoomManger',
      component: StudentRoomManger
    },
    {
      path: '/studentRoomMangerTwo',
      name: 'studentRoomMangerTwo',
      component: StudentRoomMangerTwo
    },
    {
      path: '/floorSituation',
      name: 'floorSituation',
      component: FloorSituation
    },
    {
      path: '/CheckInQuery',
      name: 'CheckInQuery',
      component: CheckInQuery
    },
    {
      path: '/BuildingQuery',
      name: 'BuildingQuery',
      component: BuildingQuery
    },
    {
      path: '/CompreHensivelyQuery',
      name: 'CompreHensivelyQuery',
      component: CompreHensivelyQuery
    },
    {
      path: '/RoomChangeApplication',
      name: 'RoomChangeApplication',
      component: RoomChangeApplication
    },
    {
      path: '/RoomChange',
      name: 'RoomChange',
      component: RoomChange
    },
    {
      path: '/RoomChangeDetial',
      name: 'RoomChangeDetial',
      component: RoomChangeDetial
    },
    {
      path: '/RoomChangeSH',
      name: 'RoomChangeSH',
      component: RoomChangeSH
    },
    {
      path: '/RoomChangeQR',
      name: 'RoomChangeQR',
      component: RoomChangeQR
    },
    {
      path: '/RepairApply',
      name: 'RepairApply',
      component: RepairApply
    },
    {
      path: '/RepairApplyDetial',
      name: 'RepairApplyDetial',
      component: RepairApplyDetial
    },
    {
      path: '/RepairManger',
      name: 'RepairManger',
      component: RepairManger
    },
    {
      path: '/RepairMangerDetial',
      name: 'RepairMangerDetial',
      component: RepairMangerDetial
    },
    {
      path: '/FusePackageProblem',
      name: 'FusePackageProblem',
      component: FusePackageProblem
    },
    {
      path: '/DelayedMaintenanceAudit',
      name: 'DelayedMaintenanceAudit',
      component: DelayedMaintenanceAudit
    },
    {
      path: '/DormitoryManagement',
      name: 'DormitoryManagement',
      component: DormitoryManagement
    },
    // {
    //   path: '/realTimeCheckSleep',
    //   name: 'realTimeCheckSleep',
    //   component: realTimeCheckSleep
    // },
    {
      path: '*',
      name: 'notfound',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js